import options from './chart.directive';

export default {
    selector: 'dtChart',
    options
};



// WEBPACK FOOTER //
// ./app/common/chart/index.js